import "../../assets/fonts/font.css";
import chipsApi from "../../js/chips-api.js";
import React, { useEffect, useState } from "react";
import Lottie from "react-lottie";
import wating from "./assets/wating.json";
import drawing from "./assets/drawing.json";
import drawed from "./assets/drawed.json";
import finished from "./assets/finished.json";
import "./Boosting.css";

import {
  moveToLogin,
  trackEvent,
  getChipsUid,
  getInsetTop,
  calc,
  showBottomSheet,
  getInsetBottom,
  openWebView,
  ios,
} from "../../js/chips-common.js";
import reloadForChecksum from "../../util/ReloadChecksum";
import DateFormat from "../../util/DateFormat";

const PAGE_STATE = {
  INIT: 0,
  DRAW: 1,
  RESULT: 2,
  END: 3,
};

function Boosting(props) {
  // Props
  const dev = props.dev;
  const domain = dev
    ? `https://api.${dev}.chips.today/`
    : "https://api.chips.today/";

  const [canDraw, setCanDraw] = React.useState(null);
  const [pageState, setPageState] = React.useState(null);
  const [energy, setEnergy] = React.useState(100);
  const [attacking, setAttacking] = React.useState(false);
  const [attackCount, setAttackCount] = React.useState(0);

  const getLottieImage = () => {
    switch (pageState) {
      case PAGE_STATE.INIT:
        return wating;
      case PAGE_STATE.DRAW:
        return drawing;
      case PAGE_STATE.RESULT:
        return finished;
      case PAGE_STATE.END:
        return finished;
      default:
        return wating;
    }
  };

  const getRandomDamage = () => {
    // random 5~15
    return Math.floor(Math.random() * 11) + 5;
  };

  const getThumbImage = () => {
    if (energy === 100) {
      return "https://cdn.chips.today/logic/images/2024/08/12/1723427396526-beeeece3-ca46-4408-902f-2b49e5eaf733.png";
    } else if (energy === 0) {
      return "https://cdn.chips.today/logic/images/2024/08/13/1723528784928-c87024e9-2b22-4fa6-8abc-f92c45c8e588.png";
    } else if (energy < 51) {
      return "https://cdn.chips.today/logic/images/2024/08/13/1723528771287-dab1319b-b0f0-4c89-a4d4-c17ef2ffcd22.png";
    } else {
      return "https://cdn.chips.today/logic/images/2024/08/12/1723427396526-beeeece3-ca46-4408-902f-2b49e5eaf733.png";
    }
  };

  const getThumbColor = () => {
    if (energy === 100) {
      return "#ff01f6";
    } else if (energy === 0) {
      return "#6e40ad";
    } else if (energy < 51) {
      return "#cb44ff";
    } else {
      return "#ff01f6";
    }
  };

  // 초기화
  useEffect(() => {
    try {
      window.moveToLogin = moveToLogin;
      // eslint-disable-next-line no-undef
      chipsApp.setThemeColor("#000000");
      // eslint-disable-next-line no-undef
      chipsApp.showHeader(false);
      // eslint-disable-next-line no-undef
      chipsApp.setFullscreen(true);
    } catch (e) {}

    if (ios) {
      setTimeout(() => {
        refresh();
        if (dev) {
          reloadForChecksum(1);
        } else {
          reloadForChecksum();
        }
      }, 300);
    } else {
      refresh();
      reloadForChecksum();
    }
  }, []);

  function refresh() {
    const now = new DateFormat().format("yyyy.MM.dd HH:mm:ss");
    if (now >= "2024.08.19 00:00:00") {
      try {
        showBottomSheet({
          icon: "https://cdn.chips.today/logic/images/2023/09/19/1695113982488-f687da0b-f2ef-4920-b2c6-d78ef7d5e582.png",
          title: "앗, 종료된 이벤트예요.",
          body: "다음 이벤트를 기대해 주세요!",
          secondary_button_text: "확인",
          secondary_button_style: "secondary",
          secondary_button_callback:
            "window.location = `${window.location.origin}/vending-machine/`",
        });
      } catch (e) {}
      return;
    }

    if (getChipsUid()) {
      setCanDraw(false);
      chipsApi.request({
        method: "get",
        url: `${domain}api/v1/benefit-events/vending_machine/boost/claim/info`,
        then: (response) => {
          const data = response.data;
          // eslint-disable-next-line no-undef
          setCanDraw(!data.claimed);
          setPageState(PAGE_STATE.INIT);
        },
      });
    } else {
      setCanDraw(false);
      setPageState(PAGE_STATE.INIT);
    }

    // TEST
    // setTimeout(() => {
    //   setPageState(PAGE_STATE.INIT);
    //   setCanDraw(true);
    // }, 300);
    // TEST
  }

  const attack = () => {
    if (!getChipsUid()) {
      showLoginBottomSheet();
      return;
    }
    if (pageState === PAGE_STATE.END) {
      window.location = `${window.location.origin}/vending-machine/`;
      return;
    }
    if (pageState === PAGE_STATE.RESULT) {
      // 결과 화면에서는 클릭 무시
      return;
    }
    if (attacking) {
      // 중복 클릭 방지
      return;
    }
    if (!canDraw) {
      // 이미 참여한 사용자
      try {
        // eslint-disable-next-line no-undef
        showBottomSheet({
          icon: "https://cdn.chips.today/logic/images/2023/09/19/1695113982488-f687da0b-f2ef-4920-b2c6-d78ef7d5e582.png",
          title: "이미 참여한 이벤트예요.",
          body: "다음 이벤트를 기대해 주세요!",
          secondary_button_text: "확인",
          secondary_button_style: "secondary",
          secondary_button_callback:
            "window.location = `${window.location.origin}/vending-machine/`",
        });
      } catch (e) {}
      return;
    }

    setAttacking(true);
    setAttackCount(attackCount + 1);
    var currentEnergy = energy - getRandomDamage();
    if (currentEnergy < 0) {
      currentEnergy = 0;
    }
    setEnergy(currentEnergy);

    if (currentEnergy === 0) {
      attackCompleted();
      setAttacking(true);
    } else {
      if (pageState !== PAGE_STATE.END) {
        setPageState(PAGE_STATE.DRAW);
      }
      setTimeout(() => {
        setAttacking(false);
      }, 250);
    }
  };

  // 카드 선택
  const attackCompleted = () => {
    if (getChipsUid()) {
      if (!canDraw) {
        try {
          // eslint-disable-next-line no-undef
          chipsApp.close();
        } catch {
          window.history.back();
        }
        return;
      }
      chipsApi.request({
        method: "post",
        url: `${domain}api/v1/benefit-events/vending_machine/boost/claim`,
        then: (response) => {
          const data = response.data;
          // 0.5sec delay once
          setPageState(PAGE_STATE.RESULT);
          setTimeout(() => {
            setPageState(PAGE_STATE.END);
          }, 3000);
        },
      });
    }
    // TEST
    // setPageState(PAGE_STATE.RESULT);
    // setTimeout(() => {
    //   setPageState(PAGE_STATE.END);
    // }, 3000);
    // TEST
  };

  function showLoginBottomSheet() {
    trackEvent("login_required");

    const attributes = {
      icon: "https://cdn.chips.today/logic/images/2023/12/29/1703834493636-4f7b84a7-7ef3-44e5-b02d-e91f6e0d315f.png",
      title: "로그인/회원가입을 해주세요!",
      body: "신규 이벤트 바로 참여하면 3일 후 랜덤 상품 당첨!<br>이벤트에 참여하려면<br>로그인 또는 회원가입을 해주세요.",
      secondary_button_text: "취소",
      primary_button_text: "시작하기",
      primary_button_callback: "moveToLogin()",
    };

    try {
      // eslint-disable-next-line no-undef
      chipsApp.showLoginBottomSheet(JSON.stringify(attributes));
    } catch (e) {}
  }

  const gageVisiblity = () => {
    switch (pageState) {
      case PAGE_STATE.INIT:
        return "visible";
      case PAGE_STATE.DRAW:
        return "visible";
      case PAGE_STATE.RESULT:
        return "hidden";
      case PAGE_STATE.END:
        return "hidden";
    }
  };

  const getRandomX = () => {
    return Math.floor(Math.random() * 289);
  };
  const getRandomY = () => {
    return Math.floor(Math.random() * 480);
  };

  return (
    <div
      style={{
        backgroundColor: "#000e5b",

        overflowY: "hidden",
        overflowX: "hidden",
        position: "absolute",
        width: calc(360),
        height: "100vh",
      }}
    >
      {pageState === PAGE_STATE.RESULT && (
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            objectFit: "fill",
            zIndex: 100,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Lottie
            style={{
              position: "relative",
              objectFit: "fill",
              pointerEvents: "none",
              marginLeft: "-2.5%",
              width: "105%",
              height: "100%",
            }}
            options={{
              loop: false,
              autoplay: true,
              animationData: drawed,
            }}
          />
        </div>
      )}

      {attacking && pageState === PAGE_STATE.DRAW && (
        <div
          style={{
            position: "absolute",
            width: "100vw",
            // height: "100vh",
            backgroundColor: "transparent",
            zIndex: 100,
          }}
        >
          <img
            src="https://cdn.chips.today/logic/images/2024/08/12/1723442841065-202ba8d4-751a-461e-b264-4af64c587f8c.png"
            style={{
              position: "absolute",
              width: calc(87),
              height: calc(81),
              backgroundColor: "transparent",
              zIndex: 100,
              left: getRandomX(),
              top: getRandomY(),
              transition: "all 0.25s", // 위치와 크기 변경에 애니메이션 적용
            }}
          />
        </div>
      )}
      {attacking && pageState === PAGE_STATE.DRAW && (
        <div
          style={{
            position: "absolute",
            width: calc(87),
            height: calc(81),
            backgroundColor: "transparent",
            zIndex: 100,
            left: getRandomX(),
            top: getRandomY(),
            transition: "all 0.25s", // 위치와 크기 변경에 애니메이션 적용
          }}
        >
          <img
            src="https://cdn.chips.today/logic/images/2024/08/12/1723442841065-202ba8d4-751a-461e-b264-4af64c587f8c.png"
            style={{
              width: calc(87),
              height: calc(81),
            }}
            zindex={100}
          />
        </div>
      )}
      {attacking && pageState === PAGE_STATE.DRAW && (
        <div
          style={{
            position: "absolute",
            width: calc(63),
            height: calc(56),
            backgroundColor: "transparent",
            zIndex: 100,
            left: calc(223),
            bottom: calc(71),
            visibility: attackCount % 2 !== 0 ? "visible" : "hidden",
            transition: "all 0.25s", // 위치와 크기 변경에 애니메이션 적용
          }}
        >
          <img
            src="https://cdn.chips.today/logic/images/2024/08/13/1723528828148-e5a0e69b-4d29-422b-b69e-ecad9c503cef.png"
            style={{
              width: calc(63),
              height: calc(56),
            }}
            zindex={100}
          />
        </div>
      )}
      {attacking && pageState === PAGE_STATE.DRAW && (
        <div
          style={{
            position: "absolute",
            width: calc(63),
            height: calc(56),
            backgroundColor: "transparent",
            zIndex: 100,
            left: calc(272),
            bottom: calc(64),
            visibility: attackCount % 2 === 0 ? "visible" : "hidden",
            transition: "all 0.25s", // 위치와 크기 변경에 애니메이션 적용
          }}
        >
          <img
            src="https://cdn.chips.today/logic/images/2024/08/13/1723528828148-e5a0e69b-4d29-422b-b69e-ecad9c503cef.png"
            style={{
              width: calc(63),
              height: calc(56),
            }}
            zindex={100}
          />
        </div>
      )}
      <div
        style={{
          display: "absolute",
          flexDirection: "column",
          width: calc(360),
          marginTop: calc(pageState !== PAGE_STATE.END ? 0 : -87),
          transition: "all 0.5s ease-in-out", // 위치와 크기 변경에 애니메이션 적용
        }}
      >
        {pageState !== PAGE_STATE.DRAW ? (
          <Lottie
            style={{
              width: "100%",
              pointerEvents: "none",
              transition: "all 0.5s ease-in-out", // 위치와 크기 변경에 애니메이션 적용
            }}
            options={{
              loop: true,
              autoplay: true,
              animationData: getLottieImage(),
            }}
          />
        ) : (
          <img
            className={attacking ? "shaking" : ""}
            src="https://cdn.chips.today/logic/images/2024/08/12/1723446689449-d2d50a3e-b1ed-4570-811b-001a4cef0c44.png"
            style={{
              width: "105vw",
              top: calc(-179),
              left: calc(-122),
              gap: 0,

              transition: "all 0.5s ease-in-out", // 위치와 크기 변경에 애니메이션 적용
            }}
          />
        )}
      </div>

      <div
        style={{
          position: "absolute",
          display: "flex",
          top: getInsetTop(),
          width: calc(360),
          zIndex: 2,
        }}
      >
        <div
          className="active-small"
          style={{
            position: "absolute",

            left: calc(20),
            width: calc(36),
            height: calc(60),
            display: "flex",
            justifyContent: "center",
          }}
          onClick={() => {
            try {
              // eslint-disable-next-line no-undef
              chipsApp.close();
            } catch (e) {
              window.history.back();
            }
          }}
        >
          <img
            style={{
              width: calc(36),
              height: calc(36),
            }}
            src="https://cdn.chips.today/logic/images/2024/07/26/1721968137732-c646d8e5-c97b-4a9e-8c7b-b3c446ab1404.png"
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            width: calc(260),
            height: calc(26),
            marginTop: calc(66),
            visibility: gageVisiblity(),
          }}
        >
          <div
            style={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              width: "100%",
              height: calc(26),
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                width: `100%`,
                height: calc(26),
                backgroundColor: "#000e5b",
                borderRadius: calc(13),
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: `${energy}%`,
                  height: calc(26),
                  backgroundColor: `${getThumbColor()}`,
                  borderRadius: calc(13),
                  transition: energy === 0 ? "" : "all 0.25s", // 위치와 크기 변경에 애니메이션 적용
                }}
              ></div>
            </div>

            <img
              src="https://cdn.chips.today/logic/images/2024/08/12/1723426837042-e9b0a3f3-721d-4584-b99b-ef23ff16eafe.png"
              style={{
                position: "absolute",
                width: "100%",
                height: calc(26),
              }}
            />
            <img
              src={getThumbImage()}
              style={{
                position: "absolute",
                marginLeft: `${energy}%`,
                width: calc(45),
                height: calc(40),
                // image's anchor point to center
                transform: "translate(-60%, 0%)",
                transition: energy === 0 ? "" : "all 0.25s", // 위치와 크기 변경에 애니메이션 적용
                visibility: gageVisiblity(),
              }}
            />
          </div>
        </div>

        <div
          style={{
            marginTop: pageState === PAGE_STATE.END ? calc(190) : calc(331),
            position: "relative",
            // bottom: getInsetBottom(),
            width: calc(360),
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {pageState === PAGE_STATE.END ? (
            <div
              style={{
                marginBottom: calc(34),
              }}
            >
              <img
                src="https://cdn.chips.today/logic/images/2024/08/13/1723522889858-4102b263-c8d9-470b-9d46-d5f6b9bc1ee3.png"
                style={{
                  objectFit: "cover",
                  width: calc(87),
                  height: calc(87),
                  marginBottom: calc(22),
                }}
              />
              <div
                style={{
                  fontFamily: "Gmarket Sans",
                  fontSize: calc(50),
                  fontWeight: 700,
                  letterSpacing: calc(-0.2),
                  textAlign: "center",
                  color: "#ffffff",
                  marginBottom: calc(22),
                }}
              >
                80개 획득!
              </div>
              <div
                style={{
                  fontFamily: "Gmarket Sans",
                  fontSize: calc(22),
                  fontWeight: 500,
                  lineHeight: calc(38),
                  letterSpacing: calc(-1),
                  textAlign: "center",
                  color: "#ffffff",
                }}
              >
                별을 20개만 더 모으면
                <div
                  className="shaking"
                  style={{
                    fontFamily: "Gmarket Sans",
                    fontSize: calc(22),
                    fontWeight: 500,
                    lineHeight: calc(38),
                    letterSpacing: calc(-1),
                    textAlign: "center",
                    color: "#FFE500",
                    display: "inline", // 한 줄로 유지하기 위해 추가
                  }}
                >
                  포인트 1000원 <span style={{ color: "#FFFFFF" }}>으로</span>
                </div>
                교환할 수 있어요
              </div>
            </div>
          ) : (
            <div
              style={{
                fontFamily: "Gmarket Sans",
                fontSize: calc(22),
                fontWeight: 500,
                lineHeight: calc(36),
                letterSpacing: calc(-1),
                textAlign: "center",
                color: "#ffffff",
                marginBottom: calc(-72),
              }}
            >
              공격버튼을 연타해서
              <br />
              몬스터의 체력을 모두 깎으면
              <br />
              포인트로 교환할 수 있는
              <br />
              별을 줄 거에요!!
            </div>
          )}
          {pageState !== PAGE_STATE.END && (
            <img
              src="https://cdn.chips.today/logic/images/2024/08/12/1723429843644-a4c0f82f-5adf-4606-82d6-bda454e69c7e.png"
              style={{
                width: calc(360),
                height: calc(194),
                marginBottom: calc(-80),
              }}
            />
          )}

          <div
            className={
              pageState !== PAGE_STATE.RESULT ? "active-large shake" : ""
            }
            onClick={attack}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: calc(312),
              height: calc(105),
              zIndex: 100,
              transition: "all 0.25s", // 위치와 크기 변경에 애니메이션 적용
            }}
          >
            <img
              src={
                pageState == PAGE_STATE.END
                  ? "https://cdn.chips.today/logic/images/2024/08/12/1723433320185-916c8627-b9c5-44fa-a0d3-8bcb19f2506a.png"
                  : "https://cdn.chips.today/logic/images/2024/08/12/1723427892841-49284ed9-c257-45e0-b694-dc155e14cc80.png"
              }
              style={{
                width: calc(312),
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Boosting;
